<template>
  <div class="px-2 bg-white my-course-wrapper">
    <course-content :planClassesId="planClassesId" :showCourseProgress="showCourseProgress" v-if="!isAudition"></course-content>
    <!-- <grade-detail :planClassesId="planClassesId" v-if="!isAudition"></grade-detail> -->
    <my-course-no-apply v-else></my-course-no-apply>
  </div>
</template>

<script>
import courseContent from './courseContent.vue'
import gradeDetail from '../course/gradeDetail/index.vue'
import myCourseNoApply from './myCourseNoApply.vue'
import Vue from 'vue'
export default {
  props: {
    planClassesId: {
      type: String,
      default: '0'
    },
    showCourseProgress: {
      type: Boolean,
      default: false
    },
    planclassesName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isAudition: false
    }
  },
  components: {
    courseContent,
    myCourseNoApply,
    gradeDetail
  },
  computed: {

  },
  created() {
    this.isAudition = Vue.ls.get('isAudition')
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.my-course-wrapper {
  height: 100%;
}
</style>
